<template>
  <div class="y_class-container">
    <fixed-header-table :fixed="yClasses != null">
      <tr slot="header">
        <th>予測対象名</th>
        <th>割合</th>
      </tr>
      <tr v-for="(yClass, index) in yClasses">
        <td>{{yClass}}</td>
        <td>{{yClassSizes[index] | percentage(1)}}%</td>
      </tr>
    </fixed-header-table>
  </div>
</template>

<script lang="js">
export default {
  name: 'YClassCmp',
  props: {
    yClasses: [],
    yClassSizes: []
  }
}
</script>

<style scoped>
  .y_class-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    padding: 16px 20px;
  }

  .y_class-container > div > table.table-body {
    /*max-height: 500px;*/
    max-height: 440px;
    flex-grow: 1;
  }

  /* tbody部分だけ可変にするなら -60px で指定*/

  /*
  .y_class-main-container {
    flex-grow: 1;
    padding: 16px 20px;
  }
  .y_class-ranking-container {
    display: flex;
    flex-direction: column;
  }
  .y_class-ranking-container > div {
    max-height: 430px;
    flex-grow: 1;
  }
  */
</style>



// WEBPACK FOOTER //
// src/components/model/detail/y_class.vue